import React from "react";
import { motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { POST_REG_STEPS } from "@/constants/content";

const MarathonSchedule = () => (
  <section id="schedule" className="section-pad relative">
    <div className="container-x">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] items-start">
        <div>
          <div className="chip"><CalendarClock className="w-3 h-3" /> Marathon Schedule</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
            When Will The Marathon Start?
          </h2>
          <p className="mt-4 text-slate-600 max-w-lg leading-relaxed">
            The official marathon schedule will be announced exclusively inside the private
            WhatsApp Community after all available seats are filled. Reserve early — seats
            are limited and go quickly.
          </p>
        </div>

        <div className="relative rounded-3xl glass-light border border-white/70 shadow-premium p-5 sm:p-7">
          <div className="aurora opacity-30" aria-hidden />
          <div className="relative z-10">
            <div className="text-[11px] font-mono uppercase tracking-widest text-emerald-700">
              After registration, you will
            </div>
            <ul className="mt-4 space-y-3">
              {POST_REG_STEPS.map((s, i) => (
                <motion.li
                  key={s.step}
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  className="flex items-center gap-4 p-3 rounded-2xl bg-white/70 border border-slate-100"
                >
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-600 to-emerald-500 text-white grid place-items-center font-display font-bold text-sm">
                    {s.step}
                  </div>
                  <div className="text-slate-800 font-medium">{s.label}</div>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MarathonSchedule;
